import {
  HttpClientModule,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { es } from 'date-fns/locale';

import { routes } from './app.routes';
import { ApiInterceptor } from './interceptors/api-interceptor.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { CustomPaginatorIntl } from './shared/config/custom-paginator-intl';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  provideNativeDateAdapter,
} from '@angular/material/core';
import {
  DateFnsAdapter,
  MAT_DATE_FNS_FORMATS,
} from '@angular/material-date-fns-adapter';
import { provideToastr } from 'ngx-toastr';
// import { es } from '@fullcalendar/core/internal-common';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(HttpClientModule),
    provideAnimations(),
    provideToastr(),
    provideHttpClient(withInterceptors([ApiInterceptor, ErrorInterceptor])),
    // provideNativeDateAdapter(),
    provideRouter(routes),
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
    { provide: MAT_DATE_LOCALE, useValue: es },
    { provide: DateAdapter, useClass: DateFnsAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS },
  ],
};
